import { createOwnUpStyle } from './helpers';
/**
 * A collection of global styles
 */

export var GlobalVariants = createOwnUpStyle({
  variants: {
    // --- GLOBAL VARIANTS ---

    /**
     * Centered text
     */
    centered: {
      textAlign: 'center'
    },

    /**
     * Start/Left-aligned text
     */
    start: {
      textAlign: 'start'
    },

    /**
     * End/Right-aligned text
     */
    end: {
      textAlign: 'end'
    },

    /**
     * Fill the whole horizontal space
     */
    fillWidth: {
      width: '100%'
    },
    // --- AUTOMATICALLY APPLIED VARIANTS ---

    /**
     * Variant automatically applied on Mobile Screens.
     *
     * A {@link ScreenSizeProvider} must exist in this context
     *   to enable this functionality.
     */
    xsmall: {},

    /**
     * Variant automatically applied on Tablet screens
     *
     * A {@link ScreenSizeProvider} must exist in this context
     *   to enable this functionality.
     */
    small: {},

    /**
     * Variant automatically applied on Mobile and Tablet screens
     *
     * A {@link ScreenSizeProvider} must exist in this context
     *   to enable this functionality.
     */
    smallAndDown: {},

    /**
     * Variant automatically applied on Non-mobile screens
     *
     * A {@link ScreenSizeProvider} must exist in this context
     *   to enable this functionality.
     */
    smallAndUp: {},

    /**
     * Variant automatically applied on Small laptop screens
     *
     * A {@link ScreenSizeProvider} must exist in this context
     *   to enable this functionality.
     */
    medium: {},

    /**
     * Variant automatically applied on Non-desktop screens
     *
     * A {@link ScreenSizeProvider} must exist in this context
     *   to enable this functionality.
     */
    mediumAndDown: {},

    /**
     * Variant automatically applied on small laptop and
     *   desktop screens
     *
     * A {@link ScreenSizeProvider} must exist in this context
     *   to enable this functionality.
     */
    mediumAndUp: {},

    /**
     * Variant automatically applied on Desktop screens
     *
     * A {@link ScreenSizeProvider} must exist in this context
     *   to enable this functionality.
     */
    large: {}
  }
});